import React, { Component, Fragment } from 'react';
import {
    Input,
    Button,
    Label,
    Row,
    Col,
} from 'reactstrap';
import './Contacts.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faSpinner, faPlus, faTrashAlt, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import ContactsNotesForm from './ContactsNotesForm';
import ConfirmButton from '../Modal/ConfirmButton';
class EditContact extends Component {
    normalizeFieldValue = (value) => {
        if (Array.isArray(value)) {
            return [...value].map(item => String(item)).sort().join('|');
        }
        if (value == null) return '';
        if (typeof value === 'boolean') return value ? 'true' : 'false';
        return String(value);
    }

    isEditFormDirty = () => {
        const editFields = Array.isArray(this.props?.editCategoryCommentsArray) ? this.props.editCategoryCommentsArray : [];
        const rowChildren = this.props?.row?.children || {};
        const rowActive = this.props?.row?.active;

        return editFields.some((comment) => {
            if (!comment) return false;
            const originalValue = comment.type === 'Inactive'
                ? !rowActive
                : rowChildren[comment.type];
            return this.normalizeFieldValue(comment.value) !== this.normalizeFieldValue(originalValue);
        });
    }

    handleOpenFullContact = () => {
        const linkedID = this.props?.row?.linkedID;
        if (!linkedID) return;
        const navigate = () => {
            if (this.props?.history?.push) {
                this.props.history.push(`/contacts/${linkedID}`);
                return;
            }
            window.location.href = `/contacts/${linkedID}`;
        };

        if (!this.isEditFormDirty() && typeof this.props?.setUnsavedChanges === 'function') {
            this.props.setUnsavedChanges(false, navigate);
            return;
        }

        navigate();
    }

    render() {
        const isEditDirty = this.isEditFormDirty();
        const hasValidationErrors = this.props.editCategoryCommentsArray.filter(item => item.error).length > 0;

        return (
            <Row key={this.props.row.linkedID} className="notesFormTypeRow text-left">
                <Col sm={6} className="notesFormTypeComments">
                    {this.props.editCategoryCommentsArray.map(comment => {
                        if (comment.validation === 'list' && comment.multiline) return (
                            <Fragment key={comment.ID}>
                                <Row className="mb-2">
                                    <Label>{comment.type}</Label>
                                    <Input
                                        type="select"
                                        name={comment.ID}
                                        multiple
                                        onChange={this.props.changeComment}
                                        value={Array.isArray(comment.value) ? comment.value : []}
                                    >
                                        <option value="0">Select {comment.type}</option>
                                        {comment.list != null && comment.list
                                            .map(item => (
                                                <option key={item.ID} value={String(item.ID)}>{item.longDescription}</option>
                                            ))}
                                    </Input>
                                </Row>
                            </Fragment>
                        )
                        switch (comment.validation) {
                            case "list":
                                return (
                                    <Fragment key={comment.ID}>
                                        <Row key={comment.ID} className="">
                                            {typeof (comment.list) !== 'undefined' ?
                                                <>
                                                    <Label>{comment.type}</Label>
                                                    <Input type="select" name={comment.ID}
                                                        value={isNaN(parseInt(comment.value) && parseInt(comment.value) > 0) ? 0 : parseInt(comment.value)}
                                                        onChange={this.props.changeComment}>
                                                        <option value="0">Select</option>
                                                        {comment.list != null && comment.list.map(item => (
                                                            <option key={item.ID} value={item.ID}>{item.longDescription}</option>
                                                        ))
                                                        }
                                                    </Input>
                                                </>
                                                :
                                                <></>
                                            }
                                        </Row>
                                        {(Array.isArray(this.props.notesCategories?.data) &&
                                            this.props.notesCategories.data
                                                .reduce((childArray, currentValue) => childArray.concat(currentValue.children), [])
                                                .reduce((listArray, listValue) => listValue.list != null ? listArray.concat(listValue.list) : listArray, [])
                                                .findIndex(item => item.ID === parseInt(comment.value) && item.longDescription === 'Other') > -1) ?
                                            <Row>
                                                <Col md={9} className="px-1 py-1">
                                                    <Input type="text" value={this.props.otherCategories[comment.ID]} onChange={(e) => this.props.changeOtherCategory(comment.ID, e.target.value)} />
                                                </Col>
                                                <Col className="py-1 text-left p-0">
                                                    <Button
                                                        color="success"
                                                        onClick={() => this.props.addCategory(comment.ID, this.props.otherCategories[comment.ID], 'edit')}
                                                        title="Add Other"
                                                    ><FontAwesomeIcon icon={faPlus} /></Button>
                                                </Col>
                                            </Row>
                                            : <></>
                                        }
                                    </Fragment>)
                            case "date":
                                return (<Row key={comment.ID} className="">
                                    <Label>{comment.type}</Label>
                                    <Input name={comment.ID} onChange={this.props.changeComment} value={comment.value} type='date' />
                                </Row>)
                            case "checkbox":
                                return (
                                    <Row key={comment.ID} className="mb-2 pl-4 mt-1">
                                        <Label>
                                            <Input
                                                name={comment.ID}
                                                onChange={this.props.changeComment}
                                                type="checkbox"
                                                checked={comment.value === 'true' || comment.value === true}
                                            />{comment.type}
                                        </Label>
                                    </Row>
                                )
                            case null:
                                return (<Row key={comment.ID} className="">
                                    <Label>{comment.type}</Label>
                                    <Input
                                        name={comment.ID}
                                        onChange={this.props.changeComment}
                                        value={comment.value}
                                        rows={comment.multiline ? 6 : null}
                                        type={comment.multiline ? 'textarea' : 'text'}
                                    />
                                </Row>)
                            default:
                                return (
                                    <Row key={comment.ID} className="">
                                        <Label>{comment.type} {(comment.validationHint != null) ? <span className="validationHint">({comment.validationHint})</span> : <></>}</Label>
                                        <Input
                                            className={comment.error ? "is-invalid" : ''}
                                            name={comment.ID}
                                            onChange={(e) => this.props.changeComment(e, comment.validation)}
                                            value={comment.value}
                                            rows={comment.multiline ? 6 : null}
                                            type={comment.multiline ? 'textarea' : 'text'} />
                                    </Row>
                                )
                        }
                    })}
                </Col>
                <Col sm={6} >
                    <Row>
                        <Col className="notesFormTypeControls text-right">
                            <Button
                                key={'submit_' + this.props.row.linkedID}
                                color="success"
                                value={this.props.row.linkedID}
                                onClick={this.props.handleEditSubmit}
                                disabled={this.props.loading ||
                                    !isEditDirty ||
                                    hasValidationErrors}
                                title="Submit"
                            ><FontAwesomeIcon icon={this.props.loading ? faSpinner : faCheck} /></Button>
                            <Button
                                className='ml-2'
                                key={'open_' + this.props.row.linkedID}
                                color="primary"
                                onClick={this.handleOpenFullContact}
                                title="Open Full Contact"
                            ><FontAwesomeIcon icon={faExternalLinkAlt} /></Button>
                            <ConfirmButton
                                className='mx-2'
                                key={'delete_' + this.props.row.linkedID}
                                color="danger"
                                value={this.props.row.linkedID}
                                onClick={this.props.handleDelete}
                                title="Delete"
                            ><FontAwesomeIcon icon={this.props.loading && this.props.editID === this.props.row.linkedID ? faSpinner : faTrashAlt} />
                            </ConfirmButton>
                            {this.props.unsavedChanges ?
                                <ConfirmButton
                                    color="secondary"
                                    onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}
                                    title="Cancel"
                                    body="Are you sure you wish to discard your edits?"
                                ><FontAwesomeIcon icon={faTimes} />
                                </ConfirmButton>
                                :
                                <Button
                                    color="secondary"
                                    // value={this.props.row.linkedID}
                                    onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}
                                    title="Cancel"
                                ><FontAwesomeIcon icon={faTimes} />
                                </Button>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col className="text-right">
                            <ContactsNotesForm
                                {...this.props} />
                        </Col>
                    </Row>
                    {this.props.marketingActivities != null && this.props.marketingActivities.length > 0 &&
                        <Row className='mt-3'>
                            <Col>
                                {/* <Label>{comment.type}</Label> */}
                                <Input type="select"
                                // name={comment.ID}
                                // value={isNaN(parseInt(comment.value) && parseInt(comment.value) > 0) ? 0 : parseInt(comment.value)}
                                // onChange={this.props.changeComment}
                                >
                                    {this.props.marketingActivities.length > 1 && <option value="0">Select</option>}
                                    {this.props.marketingActivities.map(item => (
                                        <option key={item.ID} value={item.ID}>{item.Item}</option>
                                    ))
                                    }
                                </Input>
                                <Button
                                    color="primary"
                                    className="mt-2 w-100 mx-0"
                                    // onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}
                                    title="Preview Email"
                                >Preview Email</Button>
                                <Button
                                    color="success"
                                    className="mt-1 w-100 mx-0"
                                    // onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}
                                    title="Preview Email"
                                >Send Email</Button>
                            </Col>
                        </Row>}
                </Col>
            </Row>
        )
    }
}

export default EditContact;
